import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateUser } from 'api/users/use-update-user';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { FormDrawerWithButton, EFormDrawerWithButtonIconType } from 'components/common/form-drawer-with-button';
import type { IUserFormFields } from 'components/users/user-form';
import { UserForm } from 'components/users/user-form/user-form';
import type { IUserEditProps } from './types';

const UserEditComponent: React.FC<IUserEditProps> = (props) => {
  const { user } = props;

  const { t } = useTranslation();
  const { mutateAsync: updateUser, isLoading } = useUpdateUser(user.id);

  const handleFinish = async (values: IUserFormFields) => {
    const apiVariables = {
      name: values.name,
      email: values.email,
      role: values.role,
      phone: values.phone,
      isBlocked: values.isBlocked,
      phoneDescription: values.phoneDescription,
      bonusLimit: values.bonusLimit ?? 0,
      bonusPercent: values.bonusPercent ?? 0,
    };

    await updateUser(apiVariables);
  };

  const initialValues: IUserFormFields = {
    name: user.name,
    email: user.email,
    role: user.role,
    isBlocked: user.isBlocked,
    phone: user.phone,
    phoneDescription: user.phoneDescription,
    bonusLimit: user.bonusLimit,
    bonusPercent: user.bonusPercent,
  };

  return (
    <FormDrawerWithButton
      formComponent={UserForm}
      formProps={{ initialValues, showBlockedCheckbox: true }}
      title={t('user:edit_user')}
      isLoading={isLoading}
      iconType={EFormDrawerWithButtonIconType.EDIT}
      buttonType='text'
      onFinish={handleFinish}
    />
  );
};

export const UserEdit = withRoleGuard<IUserEditProps>(UserEditComponent, [UserRole.admin]);
